import { FilterMatchMode } from 'primereact/api';
import { Column, ColumnEditorOptions, ColumnEvent } from 'primereact/column';
import { DataTable, DataTableFilterMeta, DataTableFilterMetaData } from 'primereact/datatable';
import { InputText } from 'primereact/inputtext';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import imgDefault from '../../../../assets/img/image_default_paket.jpg';
import imgDefaultUpload from '../../../../assets/img/image_default_upload.png';
import './Products.css';
import productViewModel from "./ProductViewModel";

import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import debounce from 'lodash.debounce';
import { Image } from 'primereact/image';
import { InputSwitch } from "primereact/inputswitch";
import { useNavigate } from 'react-router-dom';
import { Products as ProductsTable } from "../../Domain/Model/Products";
import { useToast } from '../../../../Shared/hook/useToast';

interface ColumnMeta {
    field: string;
    header: string;
    editable: boolean;
}

export const Products = () => {

    const [filters, setFilters] = useState<DataTableFilterMeta>({ global: { value: null, matchMode: FilterMatchMode.CONTAINS }});

    // const toast = useRef(null);
    const { showSuccess, showError, showWarn, showInfo } = useToast();

    const navigate = useNavigate();

    const formatDate = (value: string | Date): string => {
        let date: Date;
      
        if (typeof value === 'string') {
          // Limpiar si tiene fracción de segundos excesiva
          const cleaned = value.includes('.') ? value.split('.')[0] : value;
          date = new Date(cleaned);
        } else {
          date = value;
        }
      
        // Validar si es una fecha válida
        if (isNaN(date.getTime())) return 'Fecha inválida';
      
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();
      
        return `${day}/${month}/${year}`;
      };

    const {
        getProducts,
        products,
        UpdateTableProductView,
        checkedStates,
        handleSwitchChange
      } = productViewModel();

    type LazyParamsType = {
        first: number;
        rows: number;
    };
    const [totalRecords, setTotalRecords] = useState(0);
    const [loading, setLoading] = useState(false);
    const [lazyParams, setLazyParams] = useState<LazyParamsType>({
        first: 0,
        rows: 10,
    });

    const columns: ColumnMeta[] = [
        // { field: 'productId', header: 'ID', editable: false },
        { field: 'productName', header: 'Producto', editable: true },
        { field: 'sku', header: 'SKU', editable: true },
        { field: 'salePrice', header: 'Precio', editable: true },
        { field: 'discountPrice', header: 'Descuento', editable: true },
        { field: 'stock', header: 'Stock', editable: true },
        { field: 'created', header: 'Fecha de Creación', editable: false },
        { field: 'mainImage', header: 'Imagen principal', editable: false },
        { field: 'status', header: 'Estado', editable: false },
        { field: 'options', header: 'Opciones', editable: false },
    ];


    useEffect(() => {
        const search = (filters['global'] as DataTableFilterMetaData)?.value || '';
        loadProducts(lazyParams.first ?? 0, lazyParams.rows ?? 10, search);
        
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [lazyParams, filters]);


    const loadProducts = async (first: number, rows: number, search: string = '') => {
        setLoading(true);
        const page = Math.floor(first / rows);

        try {
            const result = await getProducts(page+1, rows, search); // ya devuelve { items, totalItems }
            
            setTotalRecords(result.totalCount);
        } catch (error) {
            console.error("Error al cargar productos", error);
        } finally {
            setLoading(false);
        }
    };

    const btnOptions = (id: string)=>{

        // console.log(id.toString());
        return( 
            <div className="d-inline">
                <a href={`/update-product/${id}`} className="btn btn-dark">
                    <FontAwesomeIcon icon={icon({name: 'edit'})} />
                </a>&nbsp;
            </div>
        );
    };

    const switchChange = async (checked: boolean, id: number) => {

        try {
            await handleSwitchChange(checked, id);
            showSuccess("Se Actualizo", "Se ha actualizado el estado con éxito!");
        } catch(error) {
            showError("Error", "Error al actualizar!");
        }
    }
     
    const switchState = (value: ProductsTable) => {
        // console.log("value: ", value.status);
        return (
          <>
            <div className="d-inline switchState">
              <InputSwitch
                key={value.productId}
                checked={checkedStates[value.productId]}
                onChange={(e) => switchChange(e.value, value.productId)}
              />
            </div>
          </>
        );
      };



    const isPositiveInteger = (val: any) => {
        let str = String(val);

        str = str.trim();

        if (!str) {
            return false;
        }

        str = str.replace(/^0+/, '') || '0';
        let n = Math.floor(Number(str));

        return n !== Infinity && String(n) === str && n >= 0;
    };

    // const onCellEditComplete = async (e: ColumnEvent) => {
    //     let { rowData, newValue, field, originalEvent: event } = e;

    //     switch (field) {
    //         case 'salePrice':
    //             if (isPositiveInteger(newValue)) rowData[field] = newValue;
    //             else event.preventDefault();
    //             break;
    //         case 'discountPrice':
    //             if (isPositiveInteger(newValue)) rowData[field] = newValue;
    //             else event.preventDefault();
    //             break;
    //         case 'stock':
    //             if (isPositiveInteger(newValue)) rowData[field] = newValue;
    //             else event.preventDefault();
    //             break;
    //         default:
    //             if (newValue.trim().length > 0) {
    //                 rowData[field] = newValue;
    //             }
    //             else event.preventDefault();
    //             break;
    //     }

    //     const updated = await UpdateTableProductView(rowData);
    //     if(updated){
    //         showSuccess("Se Actualizo", "Se ha actualizado el orden con éxito!");
    //     }
    // };

    const isUpdatingRef = useRef(false);

    const onCellEditComplete = useCallback(async (e: ColumnEvent) => {
        // Guard contra doble ejecución simultánea
        if (isUpdatingRef.current) return;
        isUpdatingRef.current = true;

        try {
            const { rowData, newValue, field, originalEvent: event } = e;

            // Evita disparar si no hay cambio real
            if (rowData[field] === newValue) return;

            // Validaciones según campo
            switch (field) {
            case "salePrice":
                if (!isPositiveInteger(newValue)) {
                event.preventDefault();
                return;
                }
                break;
            case "discountPrice":
                if (!isPositiveInteger(newValue)) {
                event.preventDefault();
                return;
                }
                break;
            case "stock":
                if (!isPositiveInteger(newValue)) {
                event.preventDefault();
                return;
                }
                break;
            default:
                if (!String(newValue).trim().length) {
                event.preventDefault();
                return;
                }
            }

            // Guardamos valor anterior para poder revertir si falla
            const oldValue = rowData[field];

            // Optimistic update: actualizar visualmente la fila
            rowData[field] = field === "salePrice" ? Number(newValue) : newValue;
            rowData[field] = field === "discountPrice" ? Number(newValue) : newValue;
            rowData[field] = field === "stock" ? Number(newValue) : newValue;

            // Llamada al backend
            const update = await UpdateTableProductView(rowData);
            

            if (update) {
            showSuccess("Se Actualizó", "Se ha actualizado correctamente.");
            
            } else {
            // Revertir si hubo error
            rowData[field] = oldValue;
            showError("Error", "No se pudo actualizar. Intenta nuevamente.");
            }
        } catch (err) {
            console.error("Error onCellEditComplete:", err);
            showError("Error", "Ocurrió un error al actualizar.");
        } finally {
            // desbloquear
            // pequeña espera opcional para evitar reentradas inmediatas
            setTimeout(() => {
                isUpdatingRef.current = false;
            }, 0);
        }
    }, []);

    const cellEditor = (options: ColumnEditorOptions) => {
        // if (options.field === 'state') return noTextEditor();
        // else return textEditor(options);
        return textEditor(options);
    };

    const textEditor = (options: ColumnEditorOptions) => {
        return (
            <InputText
                type="text"
                value={options.value || ''} // Asegúrate de que options.value no sea nulo o indefinido
                onChange={(e) => options.editorCallback!(e.target.value)} 
            />
        );
    };


    const imgProducts = (data: ProductsTable)=> {

        const image = data.mainImage ? data.mainImage : imgDefault;
        return(
            <>
            
            <button className='btn-img-prod'  onClick={ ()=> navigate(`/addImages/${data.productId}`, {
                    state: {
                        nombreProducto: data.productName,
                    }
            })} >
              <Image className='img-pro' key={data.productId +'pro'} src={image} alt="Image" width="100" />
              <Image className='img-upload' key={data.productId +'pro-default'} src={imgDefaultUpload} alt="Image" width="100" />
            </button>
            </>
        );
    }

    // const priceEditor = (options: ColumnEditorOptions) => {
    //     return (
    //         <InputNumber 
    //             value={options.value || 0} // Asegúrate de que options.value no sea nulo o indefinido
    //             onValueChange={(e: InputNumberValueChangeEvent) => {
    //                 return options.editorCallback!(e.target.value);
    //             }} 
    //             mode="currency" 
    //             currency="USD" 
    //             locale="en-US" 
    //         />
    //     );
    // };

    // const priceBodyTemplate = (rowData: Product) => {
    //     return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(rowData.price);
    // };

    //  Guardamos el texto en un estado normal
    const [inputValue, setInputValue] = useState("");
    
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const debouncedSearch = useCallback(
      debounce((searchValue: string) => {
        console.log("searchValue ",searchValue);
        loadProducts(lazyParams.first ?? 1, lazyParams.rows ?? 10, searchValue);
      }, 500),
      [lazyParams]
    );
    
    // Limpieza del debounce al desmontar
    useEffect(() => {
        return () => {
            debouncedSearch.cancel();
        };
    }, [debouncedSearch]);
    
    const onGlobalFilterChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        
        setInputValue(value.trim());
        // solo dispara la búsqueda cuando hay un valor completo
        if (value.trim().length > 0) {
            
            debouncedSearch(value.trim());
        } else {
            // Si está vacío, recargar todo sin filtro
            loadProducts(lazyParams.first, lazyParams.rows, "");
        } 
    };

    const header = ()=>{
       
        return (
            <div className="d-flex flex-wrap gap-2 align-items-center justify-content-between">
                <h4 className="m-0">
                    <a href="/new-product" className="btn btn-dark"><FontAwesomeIcon icon={icon({name: 'plus'})} /> Nuevo producto</a>
                </h4>
                <span className="p-input-icon-left">
                    <i className="pi pi-search" />
                    <InputText type="search" value={inputValue} onChange={onGlobalFilterChange} placeholder="Buscar..." />
                </span>
            </div>
        )
    };

    // const paginatorLeft = <Button type="button" icon="pi pi-refresh" text />;
    // const paginatorRight = <Button type="button" icon="pi pi-download" text />;

    return (
        <>
            <div className="container-fluid">
                <div className="block-header">
                    <div className="row">
                        <div className="col-lg-6 col-md-6 col-sm-12 text-start">
                            <h2>Lista Productos</h2>
                            <ul className="breadcrumb">
                                <li className="breadcrumb-item">
                                    <a href="/home" className="text-danger"><FontAwesomeIcon icon={icon({name: 'home'})} /></a>
                                </li>
                                <li className="breadcrumb-item">Lista Productos</li>
                            </ul>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12">
                            <div className="d-flex flex-row-reverse">
                                <div className="page_action">
                                    {/* <button type="button" className="btn btn-dark"><FontAwesomeIcon icon={icon({name: 'plus'})} /> Nuevo producto</button> */}
                                </div>
                                <div className="p-2 d-flex">
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className='title-report'>
                        Aquí puedes ver los ultimos productos añadidos
                    </div> 
                </div>
                <div className='row'>
                    <div className='col-lg-12'>
                        {/* <Toast ref={toast} /> */}
                        <DataTable 
                            value={products!} 
                            lazy 
                            paginator 
                            rows={lazyParams.rows} 
                            first={lazyParams.first} 
                            totalRecords={totalRecords} 
                            loading={loading} 
                            editMode="cell" 
                            rowsPerPageOptions={[5, 10, 15, 20]} 
                            tableStyle={{ minWidth: '50rem' }} 
                            onPage={(e) => setLazyParams({first: e.first, rows: e.rows})} 
                            paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                            currentPageReportTemplate="{first} to {last} of {totalRecords}" 
                            // paginatorLeft={paginatorLeft} 
                            // paginatorRight={paginatorRight}  
                            globalFilterFields={['productName', 'salePrice', 'discountPrice', 'stock']} 
                            emptyMessage="No customers found." 
                            stateStorage="session"
                            header={header} 
                            filters={filters} 
                            onFilter={(e) => {
                                setFilters(e.filters);
                                setLazyParams({ ...lazyParams, first: 1, rows: 1 });
                            }}>
                            
                            {columns.map(({ field, header, editable  }) => {
                                    return <Column 
                                    key={field} 
                                    field={field} 
                                    header={header}
                                    body={(rowData) => {

                                        if (!rowData) return null; // Evitar errores si rowData es undefined
                                
                                        switch (field) {
                                            case "created":
                                                return formatDate(String(rowData?.created ?? ""));
                                            case "mainImage":
                                                return imgProducts(rowData);
                                            case "status":
                                                return switchState(rowData);
                                            case "options":
                                                return (
                                                <>
                                                    {btnOptions(rowData.productId)}
                                                    
                                                </>
                                            );
                                            default:
                                            return rowData[field]; // Mostrar el valor del campo en caso de no ser especial
                                        }
                                        }}

                                    editor={editable ? (options) => cellEditor(options) : undefined} 
                                    onCellEditComplete={onCellEditComplete} />
                            })}
                        </DataTable>
                    </div>
                </div>
            </div>
        </>
    );
}